<!-- 上传组件 -->
<template>
  <div>
    <ul class="gallery">

      <draggable
        v-model="files"
        name="imgfiles"
        group="people"

        @start="drag=true"
        @end="drag=false"
      >
        <li
          v-for="(file, idx) in files"
          :key="file.id"
          :style="{width: itemWidth,height:itemHight}"
        >
          <img
            :src="'http://img.yimutian.com/'+file.icon_url | aspectFill(360, 360)"
            :style="{width: itemWidth,height:itemHight}"
          ><span
            class="del_btn"
            style="cursor: pointer;"
            @click="fileDel(file, idx)"
          />
        </li>
      </draggable>
    </ul>
    <file-upload
      v-show="files.length == 0"
      ref="upload"
      :name="name"
      :post-action="postAction"
      :custom-action="customAction"
      :multiple="true"
      :size="1024 * 1024 * 100"
      v-model="filesarr"
      class="upload_area"
      extensions="gif,jpg,jpeg,png,mp4,m4v"
      accept="image/gif, image/jpg, image/jpeg, image/png, video/mp4, video/x-m4v"
      @input="updatetFiles"
      @input-file="inputFile"
    >
      <div class="upload_area">
        <img
          src="http://img.yimutian.com/crm/5d134734885b9303cb184d968c50c795.png"
          style="width: 24px;height: 24px;"
        >
        <span style="margin-top: 6px;">图片/视频</span>
      </div>
    </file-upload>
  </div>
  
</template>

<script>
import Vue from 'vue'
import { Message } from 'element-ui'
import fileUpload from '@ymt/vue-upload-component'
import draggable from 'vuedraggable'

export default {
//组件命名规范应该总是 PascalCase 的
  name: 'YmtFileUpload',
  components: {
    fileUpload,
    draggable
  },
  props: {
    maximum: {
      type: Number,
      default: 1,
    },
    refname: {
      type: String,
      default: 'upload'
    },
    files: {
      type: Array
    },
    imgval:{
      type: String,
      default: ''
    },
    id:{
      type: String,
      default: ''
    },
    itemWidth:{
      type: String,
      default: '80px'
    },
    itemHight:{
      type: String,
      default: '80px'
    }
  },
  data() {
    return {
      name:'imgfile',
      bucket: 'misc',
      postAction: '/gfw/img/upload?bucket=crm',
      filesarr:[]
    };
  },
  //方法集合
  methods: {
    async customAction(file, component) {
      if (file.file.type.indexOf('image/') == -1) {
        this.name = 'file'
        // this.postAction = 'https://up.ymt.com/video?bucket=misc'
        this.postAction = '/api/video/video-upload/?bucket=misc'
      } else {
        this.name = 'imgfile'
        this.postAction = '/gfw/img/upload?bucket=crm'
      }
      file = component.update(file, {
        postAction: this.postAction
      })
      return Vue.nextTick().then(() => {
        if (component.features.html5) {
          if (component.shouldUseChunkUpload(file)) {
            return component.uploadChunk(file)
          }
          if (file.putAction) {
            return component.uploadPut(file)
          }
          if (file.postAction) {
            return component.uploadHtml5(file)
          }
        }
        if (file.postAction) {
          return component.uploadHtml4(file)
        }
        throw new Error('No action configured')
      })
    },
    inputFile(newFile, oldFile) {
      // 自动上传
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    updatetFiles(value) {
      this.fullscreenLoading = true;
      value &&
        value.forEach(i => {
          if (i.active == false && i.success == true) {
            // 单个文件单独提交，同时清除upload文件缓存
            this.$emit('addFiles', {
              id: i.id,
              icon_url: i.response.data.filename
            })
            this.$refs.upload.remove(i)
          }
          // 不支持的文件格式，例如webp
          if (i.active === false && i.error) {
            if (i.error === 'size') {
              this.$message('图片或者视频不能超出10M，请重新上传')
              this.$refs.upload.remove(i)
            } else {
              this.$message(i.error)
              this.$refs.upload.remove(i)
            }
            this.fullscreenLoading = false
          }
        })
      if (this.$refs.upload.files.length === 0) {
        this.fullscreenLoading = false
      }
    },
    fileDel(file, idx) {
      this.$emit('delFiles', idx)
    },
  },
  
}
</script>
<style lang='less'  scoped>
/* @import url(); 引入公共css类 */
.upload_area {
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 90px;
  height: 90px;
  background: #f2f2f2;
  border-radius: 2px;
  font-size: 12px;
  color: #333333;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
  li {
    position: relative;
    display: inline-block;
    width: 90px;
    height: 90px;
    border-radius: 2px;
    list-style: none;
    margin-right: 20px;
    video {
      width: 90px;
      height: 90px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .cover {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 24px;
      background: rgba(0, 0, 0, 0.64);
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 24px;
      border-radius: 0 0 2px 2px;
    }
    & > .del_btn {
      position: absolute;
      z-index: 1;
      width: 20px;
      height: 20px;
      right: 2px;
      top: 2px;
      background: url(http://img.yimutian.com/crm/5d1c9ff47960423e111d01a2d8a0fcf9.png)
        no-repeat center center;
      background-size: 100%;
    }
    & > img {
      width: 90px;
      height: 90px;
      border-radius: 2px;
    }
    .play_btn {
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 30px;
    }
  }
}
</style>